<script setup>
import { onMounted, ref,unref, watch, toRef} from 'vue'
import { DateTime, Settings } from 'luxon';
import axios from 'axios';
import config from '@/../../../../config_public.mjs';

const props = defineProps(['memberStatus']);
let oneSearchDone = false;

const receiptCustomMessage = ref('')

watch(() => props.memberStatus,function(val){
    console.log('member:',val)
    console.log('member2:',props.memberStatus)
    oneSearchDone = true;
});

const showReceipt = ()=>{
    if(props.memberStatus){
        return Object.keys(props.memberStatus).length > 0
    }
    return false;
}

const showSearchMessage = ()=>{
   
    return !oneSearchDone ||  props.memberStatus===null;
}
const print = ()=>{
    
    var appscheme = 'tmprintassistant://';           //scheme name                                                                           Input condition:Required
    var host = 'tmprintassistant.epson.com/';        //host name                                                                             Input condition:Required
    var action       = 'print?';                     //action name                                                                           Input condition:Required
    var query_success = 'success';                   //URL to be displayed when TM Print Assistant has terminated normally.                  Input condition:Can be omitted
    var query_ver = 'ver';                           //Version number                                                                        Input condition:Required
    var query_datatype = 'data-type';                //Type of print data                                                                    Input condition:Required
    var query_data = 'data';                         //Print data                                                                            Input condition:Required
    var query_reselect = 'reselect';                 //Reconfiguration of printer upon communication error                                   Input condition:Can be omitted (Default : no)
    var query_cut = 'cut';                           //Cutter setting                                                                        Input condition:Can be omitted (Default : no)
    var query_fittowidth = 'fit-to-width';           //Scaling up or down print data in accordance with paper width Supported data-type: pdf Input condition:Can be omitted (Default : no)
    var query_paperwidth = 'paper-width';            //Specifying paper width (mm)                                                           Input condition:Can be omitted (Default : 80)
    var pdfData = '';
    var pdfPath = './receipt.pdf';                   //Path of pdf file
    var xmlData ='<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">\n' +
        '<text smooth="true" align="center"/>\n' +
        // '<image width="188" height="135" color="color_1" mode="mono">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</image>\n' +
        '<logo key1="32" key2="32" align="center"/>' +
        // '<feed unit="30"/>\n' +
        '<text dh="false" dw="false" em="false" align="center">Loterie moitié-moitié&#10;</text>\n' +
        '<text dh="true" dw="false" em="true" align="center">Chevaliers de Colomb&#10;</text>\n' +
        '<text dh="false" dw="false" em="true" align="center">CONSEIL 7188&#10;</text>\n' +
        '<text dh="false" dw="false" em="false">  Saint-François-de-Madawaska   &#10;</text>\n' +
        '<text dh="false" dw="false" em="false" font="font_b">  Tél.: '+config.organisation.phone_number+'   &#10;</text>\n' +
        '<text dh="false" dw="false" em="false" font="font_c">https://chevaliersaintfrancois7188.com &#10;</text>\n' +
        // '<text dh="false" dw="false" em="false" font="font_b" ul="true">Le client est le seul responsable de &#10;</text>\n' +
        // '<text dh="false" dw="false" em="false" font="font_b" ul="true">renouveler son numéro chaque semaine &#10;</text>\n' +
        '<text linespc="20" ul="false">&#10;</text>' +
        '<text linespc="30" em="true">'+props.memberStatus.firstname+' '+props.memberStatus.lastname+'&#10;</text>\n' +
        '<text linespc="20">&#10;</text>\n';
       

        xmlData += '<text em="false" linespc="30">Votre numéro de membre est le&#10;</text>\n' +
        // '<text em="true" smooth="false" dw="true" dh="true">'+props.memberStatus.amount+'$&#10;</text>\n' +
        '<text em="true" smooth="true" dw="true" dh="true">'+props.memberStatus.number+'&#10;</text>\n' +
        '<text linespc="20">&#10;</text>' +
        '<text em="false" smooth="true" dw="false" dh="false">Créé le&#10;</text>\n' +
        '<text em="true">'+DateTime.fromISO(props.memberStatus.creationDate).toFormat('yyyy-LL-dd')+'&#10;</text>\n' +
        '<text linespc="20">&#10;</text>' +
        // '<text em="false" linespc="30">Point de vente&#10;</text>\n' +
        // '<text em="true">'+props.memberStatus.pos_name+'&#10;</text>\n' +
        '<text linespc="20">&#10;</text>' +
        '<text linespc="30" em="false" font="font_d" ul="true">Vous devez payer le lundi 21h pour&#10; participer au tirage du mardi de &#10;chaque semaine.&#10;</text>\n' +
        '<text linespc="20" ul="false">&#10;</text>' +
        // '<text linespc="30" em="false">Garder le reçu pour réclamer votre prix&#10;</text>\n' +
        // '<text linespc="20">&#10;</text>' +
        '<text linespc="30" em="true">'+receiptCustomMessage.value+'&#10;</text>\n' +
        '<text linespc="20">&#10;</text>' +
        // '<text em="false" font="font_a">FONT A Fonter&#10;</text>\n' +
        // '<text em="false" font="font_b">FONT B Fonter&#10;</text>\n' +
        // '<text em="false" font="font_c">FONT C Fonter&#10;</text>\n' +
        // '<text em="false" font="font_d">FONT D Fonter&#10;</text>\n' +
        // '<text em="false" font="font_e">FONT E Fonter&#10;</text>\n' +
        '<text em="false" font="font_c">Permis de loterie: '+config.organisation.permit_number+'&#10;</text>\n' +
        '<text>&#10;</text>' +
        '<barcode type="code39" font="font_a" width="2" height="75" hri="below">'+props.memberStatus.number+'</barcode>\n' +
        '<cut type="feed"/>\n' +
        '</epos-print>'; //ePOS-Print XML data

    function sendXml() {
        var success = window.location.href;
        // var success = '';
        var ver = '1';
        var datatype = 'eposprintxml';
        var htmlData = '';
        var reselect = 'yes';
        var urlData = '';

        urlData = appscheme + host + action + 
            query_success + '=' + encodeURIComponent(success) + '&' + 
            query_ver + '=' + ver + '&' + 
            query_datatype + '=' + datatype + '&' + 
            query_reselect + '=' + reselect + '&' + 
            query_data + '=' + encodeURIComponent(xmlData);
        location.href = urlData;
    }

    sendXml()
}


onMounted(async ()=>{
    try{
        const res = await axios.get(`/api/v1/settings/receiptMessage`);
        
        if(res.data && res.data.value){
            receiptCustomMessage.value = res.data.value;
        }
        else{
            receiptCustomMessage.value = '';
        }
    }
    catch(err){
        console.error(err);
    }
})



</script>

<template lang="pug">
div.uk-margin-large.uk-flex.uk-flex-center
    div
        template(v-if="showReceipt()")
            //- button.uk-button.uk-button-primary.uk-width-1-1.uk-margin(@click="print") 
            //-     span(uk-icon="print")    
            //-     | Imprimer
            div#receiptViewer
                img(src="/public/logo.png")
                div(style="font-weight: light; font-size:1.2em;") Loterie moitié-moitié
                div(style="font-weight: bold; font-size:1.2em;") Chevaliers de Colomb
                div(style="font-weight:bold;") CONSEIL 7188
                div(style="font-weight:bold;") Saint-Francois-de-Madawaska 
                div(style="font-weight:light;") Tél.: {{ config.organisation.phone_number }} 
                div(style="font-weight:light;font-size:0.8em;") https://chevaliersaintfrancois7188.com
                //- div(style="text-decoration:underline;")
                //-     | Nouveau Me
                div(style="margin: 10px 0;font-weight:bold;") {{props.memberStatus.firstname}} {{props.memberStatus.lastname}}
                div Votre numéro de membre est le
                div(style="font-weight:bold;font-size:2em;") {{props.memberStatus.number}}
                div Créé le
                div(style="font-weight:bold;margin-bottom:10px;") {{DateTime.fromISO(props.memberStatus.creationDate).toFormat('yyyy-LL-dd HH:mm')}}
                //- //- div(style="font-weight:bold;margin-bottom:10px;") {{DateTime.fromISO(props.memberStatus.date).setZone('UTC-5').toFormat('yyyy-LL-dd HH:mm')}}
                //- template(v-if="props.memberStatus.amount==2")
                //-     div Payé pour le tirage du
                //-     div(style="font-weight:bold;margin-bottom:10px;") {{DateTime.fromFormat(props.memberStatus.new_endDate,'kkkkWW').plus({days:1}).toFormat('yyyy-LL-dd')}}
                //- template(v-else)
                //-     div Payé pour les tirages du
                //-     div(style="font-weight:bold;margin-bottom:10px;") {{DateTime.fromFormat(props.memberStatus.current_endDate,'kkkkWW').plus({days:1}).toFormat('yyyy-LL-dd')}} au {{DateTime.fromFormat(props.memberStatus.new_endDate,'kkkkWW').plus({days:1}).toFormat('yyyy-LL-dd')}}
                //- //- div(style="font-weight:bold;margin-bottom:10px;") {{props.memberStatus.endDate}} au {{props.memberStatus.endDate}}
                //- //- div(style="font-weight:bold;margin-bottom:10px;") {{DateTime.fromISO(props.memberStatus.endDate).toFormat('yyyy-LL-dd')}} au {{DateTime.fromISO(props.memberStatus.endDate).toFormat('yyyy-LL-dd')}}
                //- div Point de vente
                //- div(style="font-weight:bold;margin-bottom:10px;") {{props.memberStatus.pos_name}}
                div(style="text-decoration:underline;margin-bottom:10px;") 
                    | Vous devez payer le lundi 21h pour participer au tirage du mardi de chaque semaine. 
                      
                div(style="font-weight:lighter;margin-bottom:10px;") {{ receiptCustomMessage }}
                
                div(style="font-weight:lighter;font-size:0.8em;")
                    | Permis de loterie: {{ config.organisation.permit_number }}

            button.uk-button.uk-button-primary.uk-width-1-1.uk-margin(@click="print") 
                span(uk-icon="print")    
                | Imprimer
</template>


<style scoped>
#receiptViewer{
    text-align: center;
    width:270px;
    background:rgb(244, 244, 244);
    border:solid 1px #e1e1e1;
    padding: 25px 20px;
}

img{
    max-width: 100px;
}
</style>
